<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import PageHeader from "@/components/page-header";
import Loader from "../components/loader";
import api from "@/axios";
import {getBaseUrl} from "@/helpers/baseUrl";

export default {
  page: {
    title: "Comissões",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, Loader },
  data() {
    return {
      updating: true,
      title: "Comissões",
      items: [
        {
          text: "Financeiro",
          href: "/"
        },
        {
          text: "Comissões",
          active: true
        }
      ]
    };
  },

  mounted() {
    console.log('mounted condicoes-list_0')
    // eslint-disable-next-line no-unused-vars
    api.get(`${getBaseUrl()}api/testarapi`).then((res) => {
      console.log('then axios')
      console.log(res)
      this.updating = false
    });
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <Loader v-if="updating" style="min-height: 400px;">
    </Loader>

    <div class="row" v-if="!updating">
      <div class="col-xl-4">
        <div class="card">
          <div class="card-body border-bottom">
            <b-dropdown
                class="float-end ms-2"
                toggle-class="text-muted p-0"
                menu-class="dropdown-menu-end"
                right
                variant="white"
            >
              <template v-slot:button-content>
                <i class="mdi mdi-dots-horizontal font-size-18"></i>
              </template>
              <b-dropdown-item>Selecionar outro representante</b-dropdown-item>
              <b-dropdown-item>Selecionar outro período</b-dropdown-item>
            </b-dropdown>

            <div>
              <div class="mb-4 me-3">
                <i class="mdi mdi-account-circle text-primary h1"></i>
              </div>

              <div>
                <h5 class>João da Silva</h5>
                <p class="text-muted mb-1">joao@empresa.com.br</p>
                <p class="text-muted mb-0">#SK1234</p>
              </div>
            </div>
          </div>
          <div class="card-body border-bottom">
            <div>
              <div class="row">
                <div class="col-sm-6">
                  <div>
                    <p class="text-muted mb-2">Saldo Disponível</p>
                    <h5>R$ 9.148,00</h5>
                  </div>
                </div>
                <div class="col-sm-6">
                  <div class="text-sm-end mt-4 mt-sm-0">
                    <p class="text-muted mb-2">Comparado mês anterior</p>
                    <h5>
                      + R$ 215,53
                      <span class="badge bg-success ms-1 align-bottom">+ 1.3 %</span>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Notificações</h4>

            <div>
              <ul class="verti-timeline list-unstyled">
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="d-flex">
                    <div class="me-3">
                      <i class="bx bx-user-plus h2 text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div>
                        <h5 class="font-size-14">Novo cliente #SK00099</h5>
                        <p class="text-muted">
                          Belo Horizonte - MG
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="d-flex">
                    <div class="me-3">
                      <i class="bx bx-copy-alt h2 text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div>
                        <h5 class="font-size-14">Faturamento Pedido 000998</h5>
                        <p class="text-muted">
                          Vitória, ES - R$ 9.584,00
                        </p>
                      </div>
                    </div>
                  </div>
                </li>

                <li class="event-list">
                  <div class="event-timeline-dot">
                    <i class="bx bx-right-arrow-circle"></i>
                  </div>
                  <div class="d-flex">
                    <div class="me-3">
                      <i class="bx bx-cloud-download h2 text-primary"></i>
                    </div>
                    <div class="flex-grow-1">
                      <div>
                        <h5 class="font-size-14">Material de apoio</h5>
                        <p class="text-muted">
                          Mídia produto #SK00077
                        </p>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>

      <div class="col-xl-8">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title">Apuração de Comissões</h4>

            <div class="row">
              <div class="col-lg-4">
                <div class="border p-3 rounded mt-4">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                          class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-18"
                      >
                        <i class="mdi mdi-calendar-alert"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Abril</h5>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <div class="text-muted mt-3">
                        <p>R$ 1.944.850,00</p>
                        <h4>4.05 %</h4>
                        <p class="mb-0">R$ 18.540,00</p>
                      </div>
                    </div>

                    <div class="col-lg-6 align-self-end">
                      <div class="float-end mt-3">
                        <a href="javascript: void(0);" class="btn btn-primary">Detalhes</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="border p-3 rounded mt-4">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span
                          class="avatar-title rounded-circle bg-soft bg-primary text-primary font-size-18"
                      >
                        <i class="mdi mdi-calendar-arrow-left"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Março</h5>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <div class="text-muted mt-3">
                        <p>R$ 2.488.000,00</p>
                        <h4>5.08 %</h4>
                        <p class="mb-0">R$ 24.800,00</p>
                      </div>
                    </div>

                    <div class="col-lg-6 align-self-end">
                      <div class="float-end mt-3">
                        <a href="javascript: void(0);" class="btn btn-primary">Detalhes</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-4">
                <div class="border p-3 rounded mt-4">
                  <div class="d-flex align-items-center mb-3">
                    <div class="avatar-xs me-3">
                      <span class="avatar-title rounded-circle bg-soft bg-info text-info font-size-18">
                        <i class="mdi mdi-calendar-account"></i>
                      </span>
                    </div>
                    <h5 class="font-size-14 mb-0">Acumulado 2023</h5>
                  </div>

                  <div class="row">
                    <div class="col-lg-6">
                      <div class="text-muted mt-3">
                        <p>R$ 10.588.000,00</p>
                        <h4>4.12 %</h4>
                        <p class="mb-0">R$ 4.577.641,10</p>
                      </div>
                    </div>

                    <div class="col-lg-6 align-self-end">
                      <div class="float-end mt-3">
                        <a href="javascript: void(0);" class="btn btn-primary">Detalhes</a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Últimos Lançamentos</h4>

            <div class="table-responsive">
              <table class="table table-nowrap table-centered mb-0 align-middle">
                <thead>
                <tr>
                  <th scope="col">Estado</th>
                  <th scope="col">Documento</th>
                  <th scope="col">Emissão</th>
                  <th scope="col">Vencimento</th>
                  <th scope="col" colspan="2" >Valor</th>
                </tr>
                </thead>
                <tbody>
                <tr>
                  <th scope="row">
                    <div class="d-flex align-items-center">
                      <div class="avatar-xs me-3">
                          <span class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-18">
                            <span>ES</span>
                          </span>
                      </div>
                    </div>
                  </th>
                  <td>
                    <div class="text-muted">000888</div>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">01/04/2023</h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">01/04/2023</h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">2.562,00</h5>
                  </td>
                  <td style="width: 120px;">
                    <a href="javascript: void(0);" class="btn btn-primary btn-sm w-xs">Visualizar</a>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <div class="d-flex align-items-center">
                      <div class="avatar-xs me-3">
                          <span class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-18">
                            <span>ES</span>
                          </span>
                      </div>
                    </div>
                  </th>
                  <td>
                    <div class="text-muted">9970001</div>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">01/04/2023</h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">01/04/2023</h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">921,00</h5>
                  </td>
                  <td>
                    <a href="javascript: void(0);" class="btn btn-primary btn-sm w-xs">Visualizar</a>
                  </td>
                </tr>
                <tr>
                  <th scope="row">
                    <div class="d-flex align-items-center">
                      <div class="avatar-xs me-3">
                          <span class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-18">
                            <span>ES</span>
                          </span>
                      </div>
                    </div>
                  </th>
                  <td>
                    <div class="text-muted">3726.06</div>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">02/04/2023</h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">02/04/2023</h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">823,00</h5>
                  </td>
                  <td>
                    <a href="javascript: void(0);" class="btn btn-primary btn-sm w-xs">Visualizar</a>
                  </td>
                </tr>

                <tr>
                  <th scope="row">
                    <div class="d-flex align-items-center">
                      <div class="avatar-xs me-3">
                          <span class="avatar-title rounded-circle bg-soft bg-warning text-warning font-size-18">
                            <span>ES</span>
                          </span>
                      </div>
                    </div>
                  </th>
                  <td>
                    <div class="text-muted">7525.47</div>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">03/04/2023</h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">03/04/2023</h5>
                  </td>
                  <td>
                    <h5 class="font-size-14 mb-1">4.256,20</h5>
                  </td>
                  <td>
                    <a href="javascript: void(0);" class="btn btn-primary btn-sm w-xs">Visualizar</a>
                  </td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>

  </Layout>
</template>